import { Button, Link, Stack, Typography } from '@mui/material'
import modalEmitter from '../ModalComponent/modalEmitter'
import { ProjectExternalLinksModalBody } from '../Modals'
import { EXTERNAL_LINKS_INLINE_MAX } from '../../consts/projectExternalLinks'
import { websiteHref } from '../../utils/common'
import { linkStyle } from './ProjectInfo/style'

type ProjectExternalLinksSectionProps = {
  links: string[]
}

export const ProjectExternalLinksSection = ({ links }: ProjectExternalLinksSectionProps) => {
  const externalLinks = links.filter((link) => link.trim().length > 0)
  if (externalLinks.length === 0) {
    return null
  }

  const openExternalLinksModal = () => {
    modalEmitter.emitOpenModal({
      dialog: {
        title: 'Дополнительные ссылки',
        body: <ProjectExternalLinksModalBody links={externalLinks} />,
        modalToCentrPosition: true,
      },
    })
  }

  if (externalLinks.length > EXTERNAL_LINKS_INLINE_MAX) {
    return (
      <Button
        variant="follow"
        onClick={openExternalLinksModal}
        sx={{ alignSelf: 'flex-start', maxHeight: 32 }}
      >
        Дополнительные ссылки
      </Button>
    )
  }

  return (
    <Stack gap={1} width="100%" sx={{ minWidth: 0 }}>
      <Typography variant="black-14-medium" sx={{ lineHeight: '18px' }}>
        Дополнительные ссылки
      </Typography>
      <Stack gap={1} width="100%" sx={{ minWidth: 0 }}>
        {externalLinks.map((link) => (
          <Link
            key={link}
            component="a"
            href={websiteHref(link)}
            target="_blank"
            rel="noopener noreferrer"
            variant="black-14-light"
            noWrap
            title={link}
            sx={{ ...linkStyle, display: 'block', maxWidth: '100%' }}
          >
            {link}
          </Link>
        ))}
      </Stack>
    </Stack>
  )
}
